import React, { useMemo, useState } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Login } from './login/Login';
import { WebUxContextProvider } from './WebUx/WebUxContext';
import { WebUx } from './WebUx/WebUx';
import { ConfigProvider, Empty } from 'antd';
import { AuthCheck } from './login/AuthCheck';
import './i18n/i18n';
import en_US from 'antd/locale/en_US';
import sv_SE from 'antd/locale/sv_SE';
import si_LK from 'antd/locale/si_LK';
import fr_FR from 'antd/locale/fr_FR';
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/sv';
import 'dayjs/locale/si';
import 'dayjs/locale/fr-ch';
import dayjs from 'dayjs';
import { ChartOfAccountsPage } from './WebUx/ChartOfAccounts/ChartOfAccountsPage';
import { TransactionsPage } from './WebUx/Transactions/TransactionsPage';
import { GeneralLedgerPage } from './WebUx/GeneralLedger/GeneralLedgerPage';
import { SitesPage } from './WebUx/Sites/SitesPage';
import { ItemsPage } from './WebUx/items/ItemsPage';
import { VendorsPage } from './WebUx/Vendors/VendorsPage';
import { TaxesPage } from './WebUx/Taxes/TaxesPage';
import { WarehousePage } from './WebUx/Warehouses/WarehousePage';
import { PettyCashPage } from './WebUx/PettyCash/PettyCashPage';
import { BillPage } from './WebUx/Bills/BillPage';
import { EmailTemplatesPage } from './WebUx/EmailTemplates/EmailTemplatesPage';
import { UsersPage } from './WebUx/Users/UsersPage';
import { TrialBalance } from './WebUx/Reports/TrialBalance';
import { UserGroupPage } from './WebUx/UserGroups/UserGroupPage';
import { NewUser } from './NewUser/NewUser';
import { AcceptInvitation } from './AcceptInvitation/AcceptInvitation';
import { Expenses } from './WebUx/Expenses/Expenses';
import { UnderConstructionPage } from './WebUx/UnderConstruction/UnderConstructionPage';
import { PettyCashItemPage } from './WebUx/PettyCash/PettyCashItemPage';
import { MyPettyCashItemPage } from './WebUx/PettyCash/MyPettyCashPage';
import { IncomesPage } from './WebUx/Incomes/IncomesPage';

function App() {
  const { i18n } = useTranslation();
  const { language } = i18n;

  const locale = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires

    dayjs.locale(
      language === 'fr_FR'
        ? 'fr-ch'
        : language === 'sv_SE'
          ? 'sv'
          : language === 'si_LK'
            ? 'si'
            : 'en',
    );
    const loc =
      language === 'fr_FR'
        ? fr_FR
        : language === 'sv_SE'
          ? sv_SE
          : language === 'si_LK'
            ? si_LK
            : en_US;
    return loc;
  }, [language]);

  return (
    <ConfigProvider locale={locale}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/new-user" element={<NewUser />} />
        <Route
          path="/accept-invitation/:otpId"
          element={<AcceptInvitation />}
        />
        <Route
          path="/webux"
          element={
            <WebUxContextProvider>
              <WebUx />
            </WebUxContextProvider>
          }
        >
          <Route path="chart-of-accounts" element={<ChartOfAccountsPage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="incomes" element={<IncomesPage />} />
          <Route path="general-ledger" element={<GeneralLedgerPage />} />
          <Route path="items" element={<ItemsPage />} />
          <Route path="vendors" element={<VendorsPage />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="sales-taxes" element={<TaxesPage />} />
          <Route path="reports/trial-balance" element={<TrialBalance />} />
          <Route path="warehouses" element={<WarehousePage />} />
          <Route path="petty-cash" element={<PettyCashPage />} />
          <Route
            path="petty-cash/:pettyCashId/items"
            element={<PettyCashItemPage user={false} />}
          />
          <Route path="my-petty-cash" element={<MyPettyCashItemPage />} />
          <Route path="bills" element={<BillPage />} />
          <Route path="email-templates" element={<EmailTemplatesPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="user-groups" element={<UserGroupPage />} />
          <Route path="expenses" element={<Expenses />} />
          <Route
            path="under-construction"
            element={<UnderConstructionPage />}
          />
          <Route path="*" element={<Empty />} />
        </Route>
        <Route path="*" element={<AuthCheck />} />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
